"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenshareIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const ScreenshareIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "24", height: "24" }, props, { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("g", { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 20L9 20L9 22L6 22C4.89543 22 4 21.1046 4 20L4 4C4 2.89543 4.89543 2 6 2L18 2C19.1046 2 20 2.89543 20 4L20 20C20 21.1046 19.1046 22 18 22L15 22L15 20L18 20L18 4L6 4L6 20ZM13.4142 10.4142L12 9L11.9976 9.00244L11.9951 9L10.5809 10.4142L10.5834 10.4167L7.75403 13.246L9.16824 14.6602L10.9951 12.8333L10.9951 21C10.9951 21.5523 11.4428 22 11.9951 22C12.5474 22 12.9951 21.5523 12.9951 21L12.9951 12.8284L14.8269 14.6602L16.2411 13.246L13.4118 10.4167L13.4142 10.4142Z", fill: color !== null && color !== void 0 ? color : theme.colors.white }) }) })));
};
exports.ScreenshareIcon = ScreenshareIcon;
//# sourceMappingURL=screenshare_icon.js.map